"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLegacyBaseDriverFromWrapper = exports.getBaseReactDriver = exports.isBaseDriver = exports.simulateMouseOut = exports.simulateMouseOver = exports.pressKey = exports.enterValue = exports.simulateBlur = exports.simulateClick = exports.createBaseDriverList = void 0;
var test_utils_1 = require("react-dom/test-utils");
var __1 = require("../..");
var createBaseDriverList = function (drivers) {
    var list = {
        count: function () { return drivers.length; },
        map: function (fn) { return drivers.map(fn); },
        filter: function (fn) { return (0, exports.createBaseDriverList)(drivers.filter(fn)); },
        get: function (idx) { return drivers[idx]; },
        toArray: function () { return drivers; },
        getText: function () { return drivers.map(function (d) { return d.getText(); }); },
        getAttribute: function (name) { return drivers.map(function (d) { return d.getAttribute(name); }); },
        clickOn: function (idx) { return list.get(idx).click(); }
    };
    return list;
};
exports.createBaseDriverList = createBaseDriverList;
var simulateClick = function (elem) {
    var event = document.createEvent('HTMLEvents');
    event.initEvent('click', true, false);
    elem.dispatchEvent(event);
};
exports.simulateClick = simulateClick;
var simulateBlur = function (elem) {
    var event = document.createEvent('HTMLEvents');
    event.initEvent('blur', true, false);
    elem.dispatchEvent(event);
};
exports.simulateBlur = simulateBlur;
var enterValue = function (elem, value) {
    elem.value = value;
    test_utils_1.Simulate.change(elem);
};
exports.enterValue = enterValue;
var pressKey = function (elem, keyCode) {
    var event = new Event('keydown', { bubbles: true });
    event.keyCode = keyCode;
    elem.dispatchEvent(event);
};
exports.pressKey = pressKey;
var simulateMouseOver = function (elem) {
    test_utils_1.Simulate.mouseOver(elem);
};
exports.simulateMouseOver = simulateMouseOver;
var simulateMouseOut = function (elem) {
    test_utils_1.Simulate.mouseOut(elem);
};
exports.simulateMouseOut = simulateMouseOut;
var isBaseDriver = function (elemOrDriver) {
    return !!elemOrDriver.findAll;
};
exports.isBaseDriver = isBaseDriver;
var getBaseReactDriver = function (elemOrDriver) {
    var elem = (0, exports.isBaseDriver)(elemOrDriver) ? elemOrDriver.elem : elemOrDriver;
    var isChildVisible = function (selector) { return !!elem.querySelector(selector); };
    var baseDriver = {
        getText: function () { return elem.textContent || ''; },
        elem: elem,
        find: function (selector) {
            var child = elem.querySelector(selector);
            if (!child) {
                throw new Error("Element with selector ".concat(selector, " does not exist"));
            }
            return (0, exports.getBaseReactDriver)(child);
        },
        getAttribute: function (name) { return elem.getAttribute(name) || ''; },
        findAll: function (selector) {
            var bds = Array.prototype.slice.call(elem.querySelectorAll(selector)).map(exports.getBaseReactDriver);
            return (0, exports.createBaseDriverList)(bds);
        },
        isChildVisible: isChildVisible,
        waitUntilVisible: function (selector) {
            return (0, __1.eventually)(function () { return isChildVisible(selector); });
        },
        click: function () {
            (0, exports.simulateClick)(elem);
        },
        enterValue: function (value) {
            (0, exports.enterValue)(elem, value);
        },
        pressKey: function (keyCode) {
            (0, exports.pressKey)(elem, keyCode);
        },
        getDataAttr: function (name) { return elem.getAttribute("data-".concat(name)) || ''; },
        getInnerHtml: function () { return elem.innerHTML; },
        hasClass: function (name) { return elem.classList.contains(name); },
        mouseOver: function () {
            (0, exports.simulateMouseOver)(elem);
        },
        mouseOut: function () {
            (0, exports.simulateMouseOut)(elem);
        },
        mouseEnter: function () {
            test_utils_1.Simulate.mouseEnter(elem);
        },
        mouseDown: function () {
            test_utils_1.Simulate.mouseDown(elem);
        }
    };
    return baseDriver;
};
exports.getBaseReactDriver = getBaseReactDriver;
var getLegacyBaseDriverFromWrapper = function (wrapper, selector, name) {
    var namespacedSelector = ".".concat(selector);
    var elements = wrapper.querySelectorAll(namespacedSelector);
    if (elements.length === 0) {
        throw new Error("Unable to locate ".concat(name, " component for given wrapper"));
    }
    if (elements.length > 1) {
        throw new Error("There is more than one [".concat(name, "] for given wrapper. Please be more specific"));
    }
    return (0, exports.getBaseReactDriver)(elements[0]);
};
exports.getLegacyBaseDriverFromWrapper = getLegacyBaseDriverFromWrapper;
//# sourceMappingURL=base-driver.js.map